// extracted by mini-css-extract-plugin
module.exports = {"message":"Login_message__Ir1AY","validateLink":"Login_validateLink__tcA7K"};